import React from "react";
import useStyles from "./styles";

import { Grid, Button } from "@material-ui/core";

const ConfirmOrder = props => {
	const classes = useStyles();
	const { handleConfirmOrder, listProduct, bottom } = props;

	return (
		<Grid
			classes={{ root: classes.root }}
			style={{
				position: "absolute",
				bottom: bottom
			}}
		>
			<Grid classes={{ root: classes.bodyView }}>
				<Grid classes={{ root: classes.rootOrder }}>
					<Grid classes={{ root: classes.textProduct }}>
						Đã chọn mua <span>{listProduct?.length}</span> sản phẩm
					</Grid>
					<Button
						className={classes.btnDefault}
						onClick={handleConfirmOrder}
					>
						Mua ngay
					</Button>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default ConfirmOrder;
